export default __webpack_public_path__ + "static/media/Flag_of_Cyprus.faf9ab6b.svg";